module.exports = __webpack_public_path__ + "img/programme2.e1266bfc.png";